import { ForeignStateVM } from 'shell/components/shared/foreign-state-list';
import { CODE_STATE_ITALIAN } from 'shell/constants/code-state-italian';
import {
  CODE_IN_CORSO_DI_DEFINIZIONE,
  LABEL_IN_CORSO_DI_DEFINIZIONE,
} from 'shell/constants/state-in-corso-di-definizione';
import { SubjectAnpr } from 'shell/models/act-category-list';

export const stateValueCitizen = (
  padre?: SubjectAnpr,
  madre?: SubjectAnpr
): ForeignStateVM | undefined => {
  const isMother = Boolean(madre);
  const isFather = Boolean(padre);

  const isItalianMother = madre?.idNazionalita === CODE_STATE_ITALIAN;
  const isItalianFather = padre?.idNazionalita === CODE_STATE_ITALIAN;

  if (isMother && isFather) {
    // se ci sono entrambi i genitori

    if (isItalianMother) {
      // se la madre è italiana
      return {
        id: madre?.idNazionalita || '',
        value: madre?.nazionalita || '',
      };
    }

    if (isItalianFather) {
      // se la padre è italiano
      return {
        id: padre?.idNazionalita || '',
        value: padre?.nazionalita || '',
      };
    }

    if (madre?.idNazionalita === padre?.idNazionalita) {
      // se stranieri ma stessa nazionalità
      return {
        id: madre?.idNazionalita || '',
        value: madre?.nazionalita || '',
      };
    }
    // entrambi stranieri ma non la stessa nazionaltà
    return {
      id: CODE_IN_CORSO_DI_DEFINIZIONE,
      value: LABEL_IN_CORSO_DI_DEFINIZIONE,
    };
  }

  if (isFather) {
    // se solo padre

    return {
      id: padre?.idNazionalita || '',
      value: padre?.nazionalita || '',
    };
  }

  if (isMother) {
    // se solo madre

    return {
      id: madre?.idNazionalita || '',
      value: madre?.nazionalita || '',
    };
  }

  // se figlio di ignoti (non c'è nè padre nè madre)
  return {
    id: CODE_STATE_ITALIAN,
    value: 'ITALIA',
  };
};
